export const CLIENT_ONBOARDING_EVENTS = [
  "CLIENT_CREATED",
  "CLIENT_CONSENT_RECORDED",
  "BANK_ACCOUNT_VERIFICATION_FAILED",
];
export const CLIENT_PAGE_EVENTS = [
  "KYC_FAILED",
  "ORDER_PROCESSED",
  "CLIENT_ACTIVATED",
  "CLIENT_DETAILS_UPDATED",
  "BANK_ACCOUNT_VERIFIED",
  "KYC_VALIDATED",
];
export const RECENT_ORDER_EVENTS = [
  "ORDER_PROCESSING_FAILED",
  "ORDER_PAYMENT_COMPLETED",
  "ORDER_SUBMITTED",
];
export const MANDATE_EVENTS = [
  "MANDATE_CREATED",
  "MANDATE_APPROVED",
  "MANDATE_ACTIVATED",
  "MANDATE_REJECTED",
];
export const TABS = [
  {
    label: "Important",
    value: "important",
  },
  {
    label: "Others",
    value: "others",
  },
];
export const STP_PLAN_STATUS_EVENTS = [
  "STP_ACTIVATED",
  "STP_CANCELLED",
  "STP_COMPLETED",
];
export const SIP_PLAN_STATUS_EVENTS = [
  "XSIP_ACTIVATED",
  "XSIP_CANCELLED",
  "XSIP_COMPLETED",
  "XSIP_PAUSED",
];
export const SWP_PLAN_STATUS_EVENTS = [
  "SWP_ACTIVATED",
  "SWP_CANCELLED",
  "SWP_COMPLETED",
];
